<template>
  <my-dialog
    :dialog-carted="dialogShow"
    :width="390"
    title="提示"
    @confirmOk="hideDialog"
  >
    <template #content>
      <slot />
    </template>
  </my-dialog>
</template>

<script>
import MyDialog from "@components/customDialog/MyDialog";

export default {
  name: "SmallDialog",
  components: { MyDialog },
  props: {
    dialogShow: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  emits: ["closeDialog"],
  methods: {
    hideDialog() {
      this.$emit("closeDialog");
    },
  }
};
</script>

<style scoped>

</style>
